module.exports = __webpack_public_path__ + "img/couponGiftIcon.b409463a.svg";